import {FC} from 'react'
import {useTranslation} from 'react-i18next'
import {CustomModal} from '../CustomModal'
import {InputIncoterm} from './InputIncoterm'
import {InputNote} from './InputNote'
import {InputPrice} from './InputPrice'
import {InputProductName} from './InputProductName'
import {InputProductSpec} from './InputProductSpec'
import {InputProductType} from './InputProductType'
import {InputQuantumContractTolerance} from './InputQuantumContractTolerance'
import {InputQuantumSO} from './InputQuantumSO'
import {InputQuantumSORelease} from './InputQuantumSORelease'
import {InputShippingTolerance} from './InputShippingTolerance'
import {SelectIDSubSO} from './SelectIDSubSO'
import {SelectPlant} from './SelectPlant'
import {SelectRoute} from './SelectRoute'
import {SelectStorageLocation} from './SelectStorageLocation'
import {SubmitButton} from './SubmitButton'
import {useModalEditSO} from './useModalEditSO'

interface Props {
  show: boolean
  onHide: () => void
  onSubmit: () => void
}

export const ModalEditSO: FC<Props> = ({show, onHide, onSubmit}) => {
  const {t} = useTranslation()
  const {isLoading, onResetSoItem, onUpdate} = useModalEditSO()

  const handleUpdateSoItem = async () => {
    const upd = await onUpdate()
    if(upd){
      onHide()
      onSubmit()
    }
  }

  const handleCloseModal = () => {
    onResetSoItem()
    onHide()
  }

  return (
    <CustomModal centered size='lg' title={t('ubah')} show={show} onHide={handleCloseModal}>
      <SelectIDSubSO />
      <SelectRoute />
      <InputIncoterm />
      <SelectPlant />
      <SelectStorageLocation />
      <InputProductType />
      <InputProductName />
      <InputProductSpec />
      <InputQuantumContractTolerance />
      <InputQuantumSORelease />
      <InputQuantumSO />
      {/* <InputToleranceQuantumSO /> */}
      <InputShippingTolerance />
      <InputPrice />
      <InputNote />
      <SubmitButton isLoading={isLoading} onSubmit={handleUpdateSoItem} />
    </CustomModal>
  )
}
